import React, { useEffect, useState, createRef } from "react";

const LottieAnimation = ({ 
  divIsVisible, 
  animation, 
  size,
  loop
 }) => {

  let animationContainer = createRef()
  const [lottie, setLottie] = useState(null);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      import('lottie-web/build/player/lottie_light.min.js').then(lottie_lightMin =>
        setLottie(lottie_lightMin)
      );
    }
  }, []);

  useEffect(() => {
    if (lottie) {
      const anim = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: "svg",
        loop: loop ? true : false,
        autoplay: false,
        animationData:animation,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
          className: "lottie-svg-class",
          id: "lottie-svg-id"
        }
      });
      if (divIsVisible) {
        anim.play()
      }
      return () => anim.destroy();
    }
  }, [divIsVisible, animation, animationContainer, loop, lottie]);

  return (
    <div className={ `animation-container mx-auto h-full max-w-full ${size?size:''}`} ref={animationContainer} />
  )
}

export default LottieAnimation
